import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  root: ({ insideSearchBar }) => ({
    background: insideSearchBar ? theme.palette.common.white : theme.palette.secondary.light,
    color: insideSearchBar ? theme.palette.primary.dark : theme.palette.secondary.contrastText,
    paddingLeft: insideSearchBar ? theme.spacing(2) : 'inherit',
    paddingRight: insideSearchBar ? theme.spacing(2) : 'inherit',
    '& ul, & li': {
      listStyle: 'none',
      margin: 0,
      padding: 0,
    },
    '& a': {
      display: 'inline-block',
      color: insideSearchBar ? theme.palette.common.black : theme.palette.secondary.contrastText,
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5),
      fontSize: insideSearchBar ? 14 : 16,
      '&:hover': {
        color: theme.palette.grey.dark,
      },
    },
    '& h6': {
      textTransform: 'uppercase',
    },
  }),
  statesContainer: ({ insideSearchBar }) => ({
    columns: 2,
    columnGap: insideSearchBar ? '2em' : '4em',
    paddingTop: theme.spacing(4),
    marginTop: insideSearchBar ? theme.spacing(2) : theme.spacing(4),
    borderTop: insideSearchBar ? 'none' : `1px solid  ${theme.palette.grey[500]}80`,
    [theme.breakpoints.up('sm')]: {
      columns: 3,
    },
    [theme.breakpoints.up('md')]: {
      columns: insideSearchBar ? 3 : 4,
      paddingTop: insideSearchBar ? 0 : theme.spacing(8),
    },
    [theme.breakpoints.up('lg')]: {
      columns: insideSearchBar ? 4 : 5,
    },
  }),
}))
